import { useQuery } from 'react-query';
import { useBuildingIdAtom } from 'stores/building-id-atom';

import { axiosInstance } from '../axiosInstance';

export interface BuildingData {
  id: number;
  timezone: string;
  address: string;
  country?: string;
}

export const getBuildingQueryKey = (buildingId: number | null) => ['building', buildingId];

const getBuilding = async (buildingId: number | null) => {
  const { data } = await axiosInstance.get<BuildingData>(`/building/${buildingId}`);
  return data;
};

export const useGetBuilding = () => {
  const [buildingId] = useBuildingIdAtom();

  return useQuery({
    enabled: !!buildingId,
    queryKey: getBuildingQueryKey(buildingId),
    queryFn: () => getBuilding(buildingId),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
